export default "__VITE_ASSET__CWOV_BTK__$_?assetResource__"